module.exports = __webpack_public_path__ + "static/media/link.0665b7bf.svg";